import { S3FileTypeEnum } from 'constants/aws'
import { MediaType } from 'constants/media'
import { LIMIT_PAGE_BREAK } from 'constants/pagination'
import { IMedia } from 'interfaces/media'
import { SupportMessageThreadStatus } from 'interfaces/message'
import { getS3FileUrl } from './images'

export function checkValidArray<T>(array?: T[]): boolean {
  return array ? Array.isArray(array) && array.length > 0 : false
}

export function getValidArray<T>(array?: T[]): T[] {
  if (array === undefined) {
    return []
  }
  return checkValidArray(array) ? array : []
}

export function getDefaultPageSize(): number {
  const pageSizeFromLocalStorage = localStorage.getItem('pageSize')
  const defaultPageLimit =
    pageSizeFromLocalStorage && !isNaN(Number(pageSizeFromLocalStorage))
      ? Number(pageSizeFromLocalStorage)
      : LIMIT_PAGE_BREAK
  return defaultPageLimit
}

export function getDirtyValues(dirtyFields: object | boolean, allValues: object): object {
  // If *any* item in an array was modified, the entire array must be submitted, because there's no way to indicate
  // "placeholders" for unchanged elements. `dirtyFields` is true for leaves.
  if (dirtyFields === true || Array.isArray(dirtyFields)) return allValues
  // Here, we have an object
  return Object.fromEntries(
    Object.keys(dirtyFields).map(key => {
      //@ts-ignore
      return [key, getDirtyValues(dirtyFields[key], allValues[key])]
    })
  )
}

export function getS3FileUrlByMediaType(media: IMedia, organizationId: number) {
  if (media?.mediaType === MediaType.FILE) {
    return getS3FileUrl(S3FileTypeEnum.OTHER, organizationId, media?.document)
  }

  if (media?.mediaType === MediaType.VIDEO) {
    return getS3FileUrl(S3FileTypeEnum.VIDEO, organizationId, media?.video ?? media?.url ?? '')
  }

  return getS3FileUrl(S3FileTypeEnum.IMAGE, organizationId, media?.image ?? media?.originalImage)
}

export function getThreadStatusColor(status: SupportMessageThreadStatus): string {
  if (status === SupportMessageThreadStatus.UNCLAIMED) {
    return 'gray'
  }
  if (status === SupportMessageThreadStatus.CLAIMED) {
    return 'blue'
  }
  if (status === SupportMessageThreadStatus.RESOLVED) {
    return 'green'
  }
  return ''
}

export function isValidEmail(email: string) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email) || 'Enter valid email format'
}

